// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"7967de4c","415":"f6d917fe","442":"63c45f61","482":"79710bb6"}[chunkId] + ".chunk.js";
};